import React, { useEffect } from 'react';
import './Modal.css';

const TermsModal = ({ closeModal }) => {
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = ''; };
    }, []);

    return (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && closeModal()}>
            <div className="modal-box" style={{ maxWidth: '800px', maxHeight: '85vh' }}>
                <button className="modal-close" onClick={closeModal}>×</button>
                <div className="modal-header">
                    <h2>Terms and Conditions</h2>
                    <img src="/assets/Embracelogo.png" alt="Embrace" />
                </div>
                
                <div style={{ paddingRight: '10px', fontSize: '14px', lineHeight: '1.6', color: 'var(--mid-gray)', textAlign: 'left' }}>
                    <p style={{ marginBottom: '15px' }}><strong>Last Updated: {new Date().toLocaleDateString()}</strong></p>
                    
                    <p style={{ marginBottom: '15px' }}>Welcome to Embrace Beauty Aesthetics. By accessing or using our website and services, you agree to comply with and be bound by the following terms and conditions.</p>
                    
                    <h3 style={{ fontSize: '18px', color: 'var(--dark)', marginTop: '20px', marginBottom: '10px' }}>1. Use of Website</h3>
                    <p style={{ marginBottom: '15px' }}>The content of this website is for your general information and use only. It is subject to change without notice. Unauthorized use of this website may give rise to a claim for damages and/or be a criminal offense.</p>
                    
                    <h3 style={{ fontSize: '18px', color: 'var(--dark)', marginTop: '20px', marginBottom: '10px' }}>2. Appointments and Cancellations</h3>
                    <p style={{ marginBottom: '15px' }}>When booking an appointment, you agree to provide accurate and complete information. We require at least 24 hours' notice for cancellations. Failure to do so may result in a cancellation fee.</p>
                    
                    <h3 style={{ fontSize: '18px', color: 'var(--dark)', marginTop: '20px', marginBottom: '10px' }}>3. Payments and Refunds</h3>
                    <p style={{ marginBottom: '15px' }}>Payment for services is due at the time of treatment unless otherwise specified. Due to the nature of our medical aesthetic treatments, we do not offer refunds on services rendered.</p>
                    
                    <h3 style={{ fontSize: '18px', color: 'var(--dark)', marginTop: '20px', marginBottom: '10px' }}>4. Intellectual Property</h3>
                    <p style={{ marginBottom: '15px' }}>This website contains material which is owned by or licensed to us. This material includes, but is not limited to, the design, layout, look, appearance, and graphics. Reproduction is prohibited other than in accordance with the copyright notice.</p>
                    
                    <h3 style={{ fontSize: '18px', color: 'var(--dark)', marginTop: '20px', marginBottom: '10px' }}>5. Governing Law</h3>
                    <p style={{ marginBottom: '15px' }}>These terms and conditions are governed by and construed in accordance with the laws of the applicable jurisdiction, and you irrevocably submit to the exclusive jurisdiction of the courts in that location.</p>
                </div>
            </div>
        </div>
    );
};

export default TermsModal;
